import { createContext, useContext } from "react";
export var DocumentContext = createContext({
    documentId: "",
    isEditMode: false,
    setIsEditMode: function () { },
});
export var useDocumentContext = function () {
    return useContext(DocumentContext);
};
